import { useEffect, useState } from 'react';
import { PatientContext } from './PatientContext';

export const PatientContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexToMove, setTabIndexToMove] = useState(0);
  const [triggerTabChange, setTriggerTabChange] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);

  const handleTriggerTabChange = (newValue: number) => {
    setTabIndexToMove(newValue);
    setTriggerTabChange(true);
  };

  const handleClearTrigger = () => {
    setTriggerTabChange(false);
    setTabIndexToMove(tabIndex);
  };

  useEffect(() => {
    if (isFormValid && tabIndexToMove !== tabIndex) {
      setTabIndex(tabIndexToMove);
      setTriggerTabChange(false);
    }
  }, [triggerTabChange, isFormValid]);

  return (
    <PatientContext.Provider
      value={{
        tabIndex,
        handleTriggerTabChange,
        setIsFormValid,
        setTriggerTabChange,
        triggerTabChange,
        handleClearTrigger,
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};
